import { grid } from '@shared/styles';

export const FIXED_WIDTH = { width: grid(46) };
